import PreferencesPage from "@/app/(app)/(crew)/preferences";

export default PreferencesPage;
